<form [formGroup]="timeFrameFormGroup" class="flex flex-col">
  <div class="flex items-center gap-2">
    <mat-checkbox
      class="automated-reports__field"
      [formControl]="allowTimeFrame"
      (change)="formReset()"
    >
      {{ title }}
    </mat-checkbox>

    @if (helperText !== '') {
      <phoenix-info-helper [tooltip]="helperText"></phoenix-info-helper>
    }
  </div>
  @if (allowTimeFrame.value) {
    <div class="flex flex-col gap-4">
      <div class="w-full">
        <mat-radio-group
          aria-label="Select an option"
          class="flex flex-row flex-wrap gap-4"
          (change)="formReset()"
          [formControl]="timeFrameType"
        >
          <mat-radio-button value="relative">
            {{ freeText ? 'Date math' : 'Relative time frame' }}
          </mat-radio-button>

          <mat-radio-button value="specific">Specific Date</mat-radio-button>
        </mat-radio-group>
      </div>

      <div class="w-full">
        @if (freeText && timeFrameType.value === 'relative') {
          <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
            <input
              matInput
              type="text"
              name="timeFrame"
              maxlength="30"
              formControlName="relativeText"
              required
            />
          </mat-form-field>
        } @else {
          @if (timeFrameType.value === 'relative') {
            <div class="flex flex-wrap gap-4">
              <mat-form-field [subscriptSizing]="'dynamic'" class="flex-1">
                <input
                  matInput
                  type="number"
                  name="timeFrameNum"
                  formControlName="timeFrameNum"
                  required
                />
              </mat-form-field>

              <mat-form-field [subscriptSizing]="'dynamic'" class="flex-1">
                <mat-select
                  required
                  name="timeFrameFrequency"
                  formControlName="timeFrameFrequency"
                >
                  @for (option of frequencyOptions; track option.value) {
                    <mat-option [value]="option.value">
                      {{ option.label }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }

          @if (timeFrameType.value === 'specific') {
            <phoenix-date-control
              class="w-full"
              label="Specific Date"
              subscriptSizing="dynamic"
              [control]="timeFrameFormGroup.controls.timeFrameDate"
            ></phoenix-date-control>
          }
        }
        @if (timeFrame.invalid) {
          <p>
            <small>
              <mat-error>Invalid Timeframe configuration</mat-error>
            </small>
          </p>
        }
      </div>
    </div>
  }
</form>
